var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "40",
        viewBox: "0 0 30.5 40",
        width: "30.5",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip-path" } }, [
          _c("path", {
            attrs: {
              id: "Path_443",
              "clip-rule": "evenodd",
              d: "M239,32.5V48.078a4.433,4.433,0,0,1-4.444,4.422H212.944a4.433,4.433,0,0,1-4.444-4.422V16.922a4.433,4.433,0,0,1,4.444-4.422h21.612A4.433,4.433,0,0,1,239,16.922Z",
              "data-name": "Path 443",
              fill: "none",
            },
          }),
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clip-path-2" } }, [
          _c("rect", {
            attrs: {
              id: "Rectangle_553",
              "data-name": "Rectangle 553",
              fill: "none",
              height: "26",
              transform: "translate(208.5 20)",
              width: "25.5",
            },
          }),
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clip-path-4" } }, [
          _c("rect", {
            attrs: {
              id: "Rectangle_557",
              "data-name": "Rectangle 557",
              fill: "none",
              height: "15.166",
              transform: "translate(221 25.417)",
              width: "8.667",
            },
          }),
        ]),
        _vm._v(" "),
        _c("clipPath", { attrs: { id: "clip-path-6" } }, [
          _c("rect", {
            attrs: {
              id: "Rectangle_555",
              "data-name": "Rectangle 555",
              fill: "none",
              height: "16",
              transform: "translate(220 25)",
              width: "10",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Group_2632",
            "data-name": "Group 2632",
            transform: "translate(-208.5 -12.5)",
          },
        },
        [
          _c("g", { attrs: { id: "Group_910", "data-name": "Group 910" } }, [
            _c(
              "g",
              {
                attrs: {
                  id: "Group_909",
                  "clip-path": "url(#clip-path)",
                  "data-name": "Group 909",
                },
              },
              [
                _c(
                  "g",
                  { attrs: { id: "Group_908", "data-name": "Group 908" } },
                  [
                    _c(
                      "g",
                      {
                        class: { "do-anim": _vm.isAnimated },
                        attrs: {
                          id: "Group_907",
                          "clip-path": "url(#clip-path-2)",
                          "data-name": "Group 907",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            id: "Path_442",
                            d: "M221.766,27.266a1.083,1.083,0,0,0-1.532-1.532l-6.5,6.5a1.083,1.083,0,0,0-.033,1.5l5.959,6.5a1.083,1.083,0,1,0,1.6-1.464L216,33.033Z",
                            "data-name": "Path 442",
                            fill: "#9193B2",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("g", { attrs: { id: "Group_921", "data-name": "Group 921" } }, [
            _c(
              "g",
              {
                attrs: {
                  id: "Group_920",
                  "clip-path": "url(#clip-path)",
                  "data-name": "Group 920",
                },
              },
              [
                _c(
                  "g",
                  { attrs: { id: "Group_919", "data-name": "Group 919" } },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Group_918",
                          "clip-path": "url(#clip-path-4)",
                          "data-name": "Group 918",
                        },
                      },
                      [
                        _c(
                          "g",
                          {
                            attrs: {
                              id: "Group_917",
                              "data-name": "Group 917",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "Group_916",
                                  "clip-path": "url(#clip-path-2)",
                                  "data-name": "Group 916",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    staticStyle: { isolation: "isolate" },
                                    attrs: {
                                      id: "Group_915",
                                      "data-name": "Group 915",
                                      opacity: "0.3",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "Group_914",
                                          "data-name": "Group 914",
                                        },
                                      },
                                      [
                                        _c(
                                          "g",
                                          {
                                            attrs: {
                                              id: "Group_913",
                                              "clip-path": "url(#clip-path-6)",
                                              "data-name": "Group 913",
                                            },
                                          },
                                          [
                                            _c(
                                              "g",
                                              {
                                                attrs: {
                                                  id: "Group_912",
                                                  "data-name": "Group 912",
                                                },
                                              },
                                              [
                                                _c(
                                                  "g",
                                                  {
                                                    class: {
                                                      "do-anim": _vm.isAnimated,
                                                    },
                                                    attrs: {
                                                      id: "Group_911",
                                                      "clip-path":
                                                        "url(#clip-path-6)",
                                                      "data-name": "Group 911",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        id: "Path_444",
                                                        d: "M229.349,27.266a1.083,1.083,0,1,0-1.532-1.532l-6.5,6.5a1.083,1.083,0,0,0-.032,1.5l5.958,6.5a1.083,1.083,0,1,0,1.6-1.464l-5.257-5.735Z",
                                                        "data-name": "Path 444",
                                                        fill: "#9193B2",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }